import React, { useState, useRef } from "react";
import "./service-for-page.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateServicefor } from "../../features/calendarWidgetSlice";
import { Button } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const ServiceForPage = () => {
  const dispatch = useDispatch();
  const [selection, setSelection] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const serviceForform = useRef();
  const navigate = useNavigate();

  const handleOptionChange = (e) => {
    // console.log(e.target.value);
    setSelection(e.target.value);
    dispatch(updateServicefor({ servicefor: e.target.value }));
    setIsSubmitted(true);
  };

  const configNextNavLink = () => {
    if (isSubmitted) {
      if (selection === "yourself") {
        navigate(`/booking-details`);
      } else {
        navigate(`/patient-registration`);
      }
    } else {
      navigate(`/services-for`);
    }
  };

  return (
    <div className="service-for-page">
      <h1>
        Who are you looking <br /> services for?
      </h1>
      <form>
        <div onChange={handleOptionChange}>
          <input
            type="radio"
            id="radio-1"
            name="custom-radio"
            value="yourself"
          />
          <label htmlFor="radio-1" className="label-1">
            yourself
          </label>
          <input
            type="radio"
            id="radio-2"
            name="custom-radio"
            value="someone else"
          />
          <label htmlFor="radio-2" className="label-2">
            someone else
          </label>
        </div>
      </form>
      <div className="navigation-btn__group">
        <Button
          color="primary"
          variant="outlined"
          className="navigation__btn"
          endIcon={<NavigateNextIcon />}
          onClick={configNextNavLink}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default ServiceForPage;
